import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "selection-headline"
}
const _hoisted_2 = { class: "selection-pet-type" }
const _hoisted_3 = {
  key: 1,
  class: "selection-text"
}
const _hoisted_4 = {
  key: 2,
  class: "tks-ops-combi-wrapper"
}
const _hoisted_5 = {
  key: 1,
  class: "selection-headline"
}
const _hoisted_6 = { class: "selection-breed-age" }
const _hoisted_7 = { class: "selection-breed-age__breed" }
const _hoisted_8 = { class: "selection-breed-age__age" }

import { PET_TYPE, PRODUCT_GROUP } from "../../store/variables";
import { requiredRule } from "frontend-component-templates/src/store/formValidation";
import AgilaDropdownFilter from "frontend-component-templates/src/components/agilaDropdownFilter.vue";
import AgilaButton from "frontend-component-templates/src/components/agilaButton.vue";
import AgilaDatePicker from "frontend-component-templates/src/components/agilaDatePicker.vue";
import AgilaRadioButtons from "frontend-component-templates/src/components/agilaRadioButtons.vue";
import AgilaRadioImages from "frontend-component-templates/src/components/agilaRadioImages.vue";
import { ref } from "vue";
import { PetType } from "../../classes/petType";

interface Props {
  showCombi?: boolean;
  showSpecificPetType?: number;
  petTypes: PetType[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterComponent',
  props: /*@__PURE__*/_mergeModels({
    showCombi: { type: Boolean, default: false },
    showSpecificPetType: { default: null },
    petTypes: { default: null }
  }, {
    "selectedPetType": {},
    "selectedPetTypeModifiers": {},
    "selectedBreed": {},
    "selectedBreedModifiers": {},
    "selectedDate": {},
    "selectedDateModifiers": {},
    "minDate": {},
    "minDateModifiers": {},
    "maxDate": {},
    "maxDateModifiers": {},
    "hideCombiFilter": {},
    "hideCombiFilterModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["showTariffs"], ["update:selectedPetType", "update:selectedBreed", "update:selectedDate", "update:minDate", "update:maxDate", "update:hideCombiFilter"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedPetType = _useModel(__props, "selectedPetType");
const selectedBreed = _useModel(__props, "selectedBreed");
const selectedDate = _useModel(__props, "selectedDate");
const minDate = _useModel(__props, "minDate");
const maxDate = _useModel(__props, "maxDate");
const hideCombiFilter = _useModel(__props, "hideCombiFilter");
const selectedProductGroup = ref(undefined);
const productGroupTksOpsRef = ref(null);
const breedCombiRef = ref(null);
const birthdayCombiRef = ref(null);

async function showTariffs(): void {
  const validBreed = breedCombiRef.value.validate();
  const validBirthday = birthdayCombiRef.value.validate();
  const validProductGroup = props.showCombi
    ? productGroupTksOpsRef.value.validate()
    : true;

  if (validBirthday && validBreed && validProductGroup) {
    emit("showTariffs", selectedProductGroup.value?.id);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (hideCombiFilter.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "selection-opener",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (hideCombiFilter.value = false))
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "agila-icon-left-sm" }, null, -1),
          _createElementVNode("div", { class: "selection-opener-text" }, "Zurück zu Ihren Angaben", -1)
        ])))
      : _createCommentVNode("", true),
    (!hideCombiFilter.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["selection", {
      cat: props.showSpecificPetType === _unref(PET_TYPE).CAT,
      dog: props.showSpecificPetType === _unref(PET_TYPE).DOG,
      'tks-ops-combi': props.showCombi,
    }])
        }, [
          (props.showCombi)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Bitte wählen Sie die Art des Versicherungschutzes "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (!props.showSpecificPetType && !props.showCombi)
              ? (_openBlock(), _createBlock(AgilaRadioButtons, {
                  key: 0,
                  options: props.petTypes,
                  modelValue: selectedPetType.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPetType).value = $event)),
                  icon: "ident",
                  id: "radio-petType",
                  ariaLabel: "Tierart"
                }, null, 8, ["options", "modelValue"]))
              : (props.showSpecificPetType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Bitte geben Sie Rasse und Geburtstag " + _toDisplayString(props.showSpecificPetType === _unref(PET_TYPE).DOG
            ? "Ihres Hundes"
            : "Ihrer Katze") + " an ", 1))
                : (props.showCombi)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(AgilaRadioImages, {
                        id: "tksOpsProductGroup",
                        modelValue: selectedProductGroup.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedProductGroup).value = $event)),
                        class: "bg-white",
                        rules: [_unref(requiredRule)()],
                        options: [
            {
              id: _unref(PRODUCT_GROUP).TKS,
              image: 'agila-icon-tks',
              name: 'Tierkrankenschutz',
            },
            {
              id: _unref(PRODUCT_GROUP).OPS,
              image: 'agila-icon-ops',
              name: 'OP-Kostenschutz',
            },
          ],
                        ref: 
            (el) => {
              productGroupTksOpsRef.value = el;
            }
          
                      }, null, 8, ["modelValue", "rules", "options"])
                    ]))
                  : _createCommentVNode("", true)
          ]),
          (props.showCombi)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Bitte treffen Sie die Angaben zum zu versichernden Hund "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(AgilaDropdownFilter, {
                rules: [_unref(requiredRule)()],
                modelValue: selectedBreed.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedBreed).value = $event)),
                options: selectedPetType.value?.breeds,
                "data-cy": "breeds",
                id: "breeds",
                label: "Rasse",
                "show-label": true,
                "scroll-height": "40vh",
                "show-error": true,
                ref: 
            (el) => {
              breedCombiRef.value = el;
            }
          
              }, null, 8, ["rules", "modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(AgilaDatePicker, {
                rules: [_unref(requiredRule)()],
                id: "age",
                "selected-date": selectedDate.value,
                "onUpdate:selectedDate": _cache[4] || (_cache[4] = ($event: any) => ((selectedDate).value = $event)),
                "max-date": maxDate.value,
                "min-date": minDate.value,
                label: "Geburtstag des Tieres",
                "scroll-height": "40vh",
                "show-label": true,
                "show-error": true,
                ref: 
            (el) => {
              birthdayCombiRef.value = el;
            }
          
              }, null, 8, ["rules", "selected-date", "max-date", "min-date"])
            ])
          ]),
          (props.showCombi)
            ? (_openBlock(), _createBlock(AgilaButton, {
                key: 2,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showTariffs())),
                text: "Tarife anzeigen"
              }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})